var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer mainFooter"},[_vm._v("E-learning CopyRight © 2021")])}
var staticRenderFns = []

export { render, staticRenderFns }